import { PlaceholderPage } from '@/components/shell/PlaceholderPage';

export default function LegalPrivacy() {
  return (
    <PlaceholderPage titleKey="page.legal.privacy.title" bodyKey="landing.privacy.body" />
  );
}
